export enum ProtocolType {
	MQTT = "MQTT",
	KAFKA = "KAFKA",
	OPCUA = "OPCUA",
	POSTGRESQL = "POSTGRESQL",
	QUALITY_RULE = "QUALITY_RULE",
	PROFILING = "PROFILING",
}
